<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "App"
    };
</script>

<style>
    html::-webkit-scrollbar {
        display: none;
    }
    html {
        -ms-overflow-style: none;
        scroll-padding-top: 3rem;
    }
</style>
